import {configureStore} from "@reduxjs/toolkit";
import SidebarState from "./SidebarSlice";
import userState from "./userSlice";
import ItemSlice from "./ItemSlice";
import productReducer from "./ProductSlice";


const ShagoonStore = configureStore({
  reducer: {
    sidebar: SidebarState.reducer,
    products: ItemSlice,
    userData: userState.reducer,
    product: productReducer,
  }
});

export default ShagoonStore;